import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image/withIEPolyfill';
import BackgroundImage from 'gatsby-background-image';

const Image = ({
  type,
  src,
  alt,
  style,
  imgStyle,
  title,
  className,
  id,
  tag,
  children,
  backgroundColor,
  objectFit,
  objectPosition,
}) => (
  <StaticQuery
    query={graphql`
      query {
        images: allFile {
          edges {
            node {
              relativePath
              name
              childImageSharp {
                fluid(maxWidth: 2000, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      const image = data.images.edges.find((n) =>
        n.node.relativePath.includes(src),
      );

      if (!image) return null;

      return type === 'background' ? (
        <BackgroundImage
          fluid={image.node.childImageSharp.fluid}
          Tag={tag}
          id={id}
          style={style}
          className={className}
          backgroundColor={backgroundColor}
        >
          {children}
        </BackgroundImage>
      ) : (
        <Img
          fluid={image.node.childImageSharp.fluid}
          alt={alt}
          style={style}
          imgStyle={imgStyle}
          title={title}
          className={className}
          id={id}
          backgroundColor={backgroundColor}
          objectFit={objectFit || 'cover'}
          objectPosition={objectPosition || '50% 50%'}
        />
      );
    }}
  />
);

Image.propTypes = {
  type: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  style: PropTypes.object,
  imgStyle: PropTypes.object,
  title: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  tag: PropTypes.string,
  children: PropTypes.node,
  backgroundColor: PropTypes.string,
  objectFit: PropTypes.string,
  objectPosition: PropTypes.string,
};

export default Image;
